<div class="login-page">
    <form class="login-form" ngForm="loginFormGroup" method="post">
        <div class="header">
            <img src="assets/imgs/logo3.png" width="100" alt="logo">
        </div>
        <div class="description">
            <p class="title">DIGITAL EXPERIENCE PLATFORM (DXP)</p>
            <p class="sub-title">Manage website content with ease. Publish events, business listings and create
                itineraries using the power of dynamic content.</p>
        </div>

        <div class="self">
            <ig-field label="User name" icon="account_circle" [formControl]="loginFormGroup.get('userName')"
                [(ngModel)]="credential.userName">
            </ig-field>
            <ig-field label="Password" icon="vpn_key" type="password" [formControl]="loginFormGroup.get('password')"
                [(ngModel)]="credential.password">
            </ig-field>

            <div class="login-failed-alert" *ngIf="isLoginFailed">
                Login failed
            </div>

            <ig-button [isAsync]="true" (trigger)="login($event)">
                LOGIN
            </ig-button>

            <div *ngIf="accountStatus">{{accountStatus}}</div>

            <ig-link-button [isInternal]="false" [link]="supportLink">
                Forgot password?<span>Contact our team</span>
            </ig-link-button>
        </div>
    </form>

    <div class="image-container">
        <img src="https://iti-images.s3.us-east-1.amazonaws.com/imgs/v3.png" alt="" class="full-width">

        <h2 class="">Experience the DXP Dashboard 3.0</h2>
        <p>More filters, bulk editing and enhanced content management</p>
        <button class="now-available-button" (click)="openV3()">NOW AVAILABLE IN BETA</button>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/auth/login/login.component.html